import { CommonModule } from '@angular/common';
import { Component, HostListener } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Meta, Title, DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Dotcom2024Service } from '../dotcom2024.service';
import { environment } from '../../environments/environment';
import { MyharrellsService } from '../myharrells.service';
import { CanonicalService } from '../canonical.service';

@Component({
  selector: 'app-post',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './post.component.html',
  styleUrl: './post.component.css'
})
export class PostComponent {
  //in case the user clicks the back button after filtering 
  //for this to work there is code in the onInit section -- seach on "in case the"
  // @HostListener('window:popstate', ['$event'])
  // onPopState(event: Event): void {
  //   window.location.reload();
  // }


  safeURL: any;
  videoURL: string = "https://www.youtube.com/embed/aNlAyYva6FM";

  constructor(public _sanitizer: DomSanitizer, public myHarrellsService: MyharrellsService, public router: Router, public route: ActivatedRoute, private title: Title, private meta: Meta, public dotComService: Dotcom2024Service, private canonicalService: CanonicalService) {

    this.videoURL = ''; //"https://www.youtube.com/embed/aNlAyYva6FM";
    this.safeURL = this._sanitizer.bypassSecurityTrustResourceUrl(this.videoURL);

  }

  postImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/Blog-Photos/";
  baseImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/";
  imageExists: boolean = false;

  thisPost: any = {};
  otherFeaturedPost1: any;
  otherFeaturedPost2: any;
  otherFeaturedPost3: any;
  validPost: boolean = false;
  displayOops: boolean = false;


  ngOnInit(): void {

    // *** THIS PAGE IS FOR NON MATRIX POSTS - MATRIX POSTS ARE A SEPERATE BEAST IN A THIRD PARTY PLATFORM  *** 

    //meta tags for SEO
    this.title.setTitle("Harrell’s Online Education | Free CEUs & Agronomic Resources");
    this.meta.updateTag({ name: 'description', content: "Earn free CEUs and expand your agronomic knowledge with Harrell’s online education, featuring courses, videos, and industry insights." });
    this.meta.updateTag({ property: 'og:title', content: "Harrell’s Online Education | Free CEUs & Agronomic Resources" });
    this.meta.updateTag({ property: 'og:description', content: "Earn free CEUs and expand your agronomic knowledge with Harrell’s online education, featuring courses, videos, and industry insights." });
    // this.meta.updateTag({ property: 'og:image', content: "og:image here - contacts" });
    // this.meta.updateTag({ property: 'og:url', content: "og:url here - contacts" });
    this.meta.updateTag({ property: 'Twitter:card', content: "Harrell’s Online Education | Free CEUs & Agronomic Resources" });
    this.meta.updateTag({ property: 'Twitter:site', content: "Harrell’s Online Education | Free CEUs & Agronomic Resources" });
    this.meta.updateTag({ property: 'Twitter:title', content: "Harrell’s Online Education | Free CEUs & Agronomic Resources" });
    this.meta.updateTag({ property: 'Twitter:description', content: "Earn free CEUs and expand your agronomic knowledge with Harrell’s online education, featuring courses, videos, and industry insights." });
    // this.meta.updateTag({ property: 'Twitter:image', content: "twitter:image here - contacts" });
    // this.dotComService.createCanonicalURL();
    this.meta.updateTag({ name: 'author', content: "Harrell's LLC" });
    this.canonicalService.updateCanonicalURL(window.location.href);


    if (typeof window !== 'undefined') {
      const urlParams = new URLSearchParams(window.location.search);
      // Rest of the code that depends on the window object

      let postAlias = urlParams.get('id');



      if (postAlias == null) {
        //this could be a legacy link from the old site coming through 
        //that marketing used in the wild.  An example url in the old site was 
        //https://harrellstest.azurewebsites.net/Blog/Post/all-about-botrytis
        //try to get the post name from that
        if (window.location.href.toLowerCase().indexOf('/education/post/') > -1) {
          postAlias = window.location.href.toLowerCase().substring(window.location.href.toLowerCase().indexOf('/education/post/') + 11)
        }
      }

      //get the post details
      this.GetPostDetails(postAlias).then(result => {

      })
      this.GetRelatedResources(postAlias);

    }

  }


  GetPostDetails(postAlias: string) {

    return new Promise((resolve, reject) => {
      this.displayOops = false;
      this.myHarrellsService.GetEducationPostNonMatrixCourseDetail(postAlias).subscribe((post: any) => {
        this.thisPost = post[0];

        if (this.thisPost.Id == 0) {
          //post not found - it might have been marked as unpublished after it was marketed published 
          this.validPost = false
          this.displayOops = true;
          resolve('');

        }
        else {
          this.validPost = true
          let z = new Date(post.PublishDate);
          this.thisPost.PublishDate = z.toLocaleDateString("en-US");

          //THIS IS A HACK FOR LEGACY POSTS TO FORECE THE CONTENT BELOW THE IMAGE INSTEAD OF NEXT TO IT 
          //get the index of the end of each img tag
          let imgTagIndex = this.thisPost.Content.indexOf('<img');
          let imgTagEndIndex = this.thisPost.Content.indexOf('>', imgTagIndex + 1);

          //add '<br>' to the end of the img tag
          this.thisPost.Content = this.thisPost.Content.substring(0, imgTagEndIndex) + '><br><br>' + this.thisPost.Content.substring(imgTagEndIndex + 1);

          // let imgTagEndIndex2 = this.thisPost.Content.indexOf('>', imgTagEndIndex + 1);
          // let imgTagEndIndex3 = this.thisPost.Content.indexOf('>', imgTagEndIndex2 + 1);

          //ANOTHER HACK FOR LEGACY POSTS TO FIT THE NEW DESIGN - COURSES THAT REFER TO A BUTTON ON THE RIGHT TO VIEW COURSE MATERIAL
          if (this.thisPost.Content.indexOf('View Course Material') > -1) {
            let startPositionOfThisPTag = 0;
            let endPositionOfThisPTag = 0;
            let postionOfViewCourseMaterial = this.thisPost.Content.indexOf('View Course Material');
            //work backwords to find the start of the p tag
            for (let i = postionOfViewCourseMaterial; i > 0; i--) {
              if (this.thisPost.Content.toString().substring(i-3,i) == "<p>") {
                startPositionOfThisPTag = i;
                break;
              }
            }
            //work forward to find the end of the p tag
            for (let i = postionOfViewCourseMaterial; i < this.thisPost.Content.length; i++) {
              if (this.thisPost.Content.toString().substring(i,i+4) == "</p>") {
                endPositionOfThisPTag = i + 4;
                break;
              }
            }
            let z = this.thisPost.Content.substring(startPositionOfThisPTag, endPositionOfThisPTag);
            this.thisPost.Content = this.thisPost.Content.replace(z, "<h3 style='padding-top: 20px; padding-bottom:20px;'><a class='DIN2014Bold blueBackground whiteText courseLink' href= '" + this.thisPost.ResourceURL + "' target='_blank' >View Course Material</a></h3>");
          }
          //END - ANOTHER HACK FOR LEGACY POSTS TO FIT THE NEW DESIGN - COURSES THAT REFER TO A BUTTON ON THE RIGHT TO VIEW COURSE MATERIAL

          // //get the url from after santized for angular 
          if (this.thisPost.Content.indexOf('<iframe src') > -1) {
            //strip out the iframe tag and replace it with a new one that has the video url in it - one that angular can bind to


            // let startPosOfURL = this.thisPost.Content.indexOf('<iframe src') + 13;
            // this.videoURL = this.thisPost.Content.substring(startPosOfURL, this.thisPost.Content.indexOf('" allowfullscreen'))
            // this.safeURL = this._sanitizer.bypassSecurityTrustResourceUrl(this.videoURL);


            const str = this.thisPost.Content.substring(this.thisPost.Content.indexOf('<iframe'), this.thisPost.Content.indexOf('</iframe')); //'<iframe src="https://example.com" width="100" height="100"></iframe>';
            const doc = new DOMParser().parseFromString(str, 'text/html');
            this.videoURL = (doc.body.children[0] as HTMLIFrameElement).src;
            this.safeURL = this._sanitizer.bypassSecurityTrustResourceUrl(this.videoURL);



            this.thisPost.Content = this.thisPost.Content.replace('<span class="mce-shim"></span>', ''); //remove the span that is added by the tinymce editor
            let startPosOfIframe = this.thisPost.Content.indexOf('<span contenteditable="false');
            let endPosOfIframe = this.thisPost.Content.indexOf('</span>', startPosOfIframe);
            this.thisPost.Content = this.thisPost.Content.substr(0, startPosOfIframe) + this.thisPost.Content.substr(endPosOfIframe)
            this.thisPost.Content = this.thisPost.Content.replace('<p>?</span></p>', '');
          }

          //check if the image exists
          //check to see if the image exists as a jpg, if not use png and then if neiter exist the html will show a default image
          this.dotComService.checkIfImageExists(this.postImagePaths + this.thisPost.ItemAlias + ".jpg", (exists) => {
            if (exists) {
              // Success code
              this.thisPost.ImageName = this.postImagePaths + this.thisPost.ItemAlias + ".jpg"
            } else {
              // Fail code
              //this.dotComService.resourceFilteredPosts[i].ImageName = this.postImagePaths + this.dotComService.resourceFilteredPosts[i].ItemAlias + ".png"
              this.dotComService.checkIfImageExists(this.postImagePaths + this.thisPost.ItemAlias + ".png", (exists) => {
                if (exists) {
                  // Success code
                  this.thisPost.ImageName = this.postImagePaths + this.thisPost.ItemAlias + ".png"
                } else {
                  // Fail code - use default
                  this.thisPost.ImageName = this.baseImagePaths + "harrellsh.png"
                }
              })
            }
            resolve('');
          });
        }

      })
    })
  }

  GetRelatedResources(blogAlias: string) {
    //until we decide how we want to filter to the related resources just getting 3 at random 
    //get random number between 1 and 30
    let randomNum1 = Math.floor(Math.random() * 30) + 1;

    //get random number between 1 and 30 but not the first number
    let randomNum2;
    do {
      randomNum2 = Math.floor(Math.random() * 30) + 1;
    } while (randomNum2 === randomNum1);

    //get random number between 1 and 30 but not the first number or the second numb er
    let randomNum3;
    do {
      randomNum3 = Math.floor(Math.random() * 30) + 1;
    } while (randomNum3 === randomNum1 && randomNum3 === randomNum2);


    if (this.myHarrellsService.publicCourseList.length > 0) {
      this.otherFeaturedPost1 = this.myHarrellsService.publicCourseList[randomNum1]; //(randomNum1).subscribe((post: any) => {
      this.otherFeaturedPost2 = this.myHarrellsService.publicCourseList[randomNum2];
      this.otherFeaturedPost3 = this.myHarrellsService.publicCourseList[randomNum3];

    }   //get random number between 1 and 30 but not the first number or the second numb
    else {
      this.myHarrellsService.GetEducationPostsNonMatrix().subscribe((data: any) => {
        this.myHarrellsService.publicCourseList = data.filter(x => x.IsMatrixPost == false); //exclude the matrix courses from this list
        this.otherFeaturedPost1 = this.myHarrellsService.publicCourseList[randomNum1]; //(randomNum1).subscribe((post: any) => {
        this.otherFeaturedPost2 = this.myHarrellsService.publicCourseList[randomNum2];
        this.otherFeaturedPost3 = this.myHarrellsService.publicCourseList[randomNum3];

        //check for the correct image
        if (this.otherFeaturedPost1) {
          this.dotComService.checkIfImageExists(this.postImagePaths + this.otherFeaturedPost1.ItemAlias + ".jpg", (exists) => {
            if (exists) {
              // Success code
              this.otherFeaturedPost1.ImageName = this.postImagePaths + this.otherFeaturedPost1.ItemAlias + ".jpg"
            } else {
              // Fail code
              this.dotComService.checkIfImageExists(this.postImagePaths + this.otherFeaturedPost1.ItemAlias + ".png", (exists) => {
                if (exists) {
                  // Success code
                  this.otherFeaturedPost1.ImageName = this.postImagePaths + this.otherFeaturedPost1.ItemAlias + ".png"
                } else {
                  // Fail code - use default
                  this.otherFeaturedPost1.ImageName = this.baseImagePaths + "harrellsh.png"
                }
              })
            }
          });
        }

        //check for the correct image
        if (this.otherFeaturedPost2) {
          this.dotComService.checkIfImageExists(this.postImagePaths + this.otherFeaturedPost2.ItemAlias + ".jpg", (exists) => {
            if (exists) {
              // Success code
              this.otherFeaturedPost2.ImageName = this.postImagePaths + this.otherFeaturedPost2.ItemAlias + ".jpg"
            } else {
              // Fail code
              this.dotComService.checkIfImageExists(this.postImagePaths + this.otherFeaturedPost2.ItemAlias + ".png", (exists) => {
                if (exists) {
                  // Success code
                  this.otherFeaturedPost2.ImageName = this.postImagePaths + this.otherFeaturedPost2.ItemAlias + ".png"
                } else {
                  // Fail code - use default
                  this.otherFeaturedPost2.ImageName = this.baseImagePaths + "harrellsh.png"
                }
              })
            }
          });
        }

        //check for the correct image
        if (this.otherFeaturedPost3) {
          this.dotComService.checkIfImageExists(this.postImagePaths + this.otherFeaturedPost3.ItemAlias + ".jpg", (exists) => {
            if (exists) {
              // Success code
              this.otherFeaturedPost3.ImageName = this.postImagePaths + this.otherFeaturedPost3.ItemAlias + ".jpg"
            } else {
              // Fail code
              this.dotComService.checkIfImageExists(this.postImagePaths + this.otherFeaturedPost3.ItemAlias + ".png", (exists) => {
                if (exists) {
                  // Success code
                  this.otherFeaturedPost3.ImageName = this.postImagePaths + this.otherFeaturedPost3.ItemAlias + ".png"
                } else {
                  // Fail code - use default
                  this.otherFeaturedPost3.ImageName = this.baseImagePaths + "harrellsh.png"
                }
              })
            }
          });
        }

      })
    }


  }

  GoToPost(post) {

    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigateByUrl('/post?id=' + post.ItemAlias);
    });

  }


}
